export {};

declare global {
	interface Number {
		humanFileSize(): String
	}
}

Object.defineProperty(Number.prototype, 'humanFileSize', {
	enumerable: false,
	value: function(): string {
		var i: number = Math.floor(Math.log(this) / Math.log(1024));
		return parseFloat((this / Math.pow(1024, i)).toFixed(2)) * 1 + ' ' + ['o', 'Ko', 'Mo', 'Go', 'To'][i];
	}
});